import { floor, sortBy } from 'lodash';

import type { EnterpriseProgram, PaginatedEnterprisePrograms } from 'bundles/enterprise-admin-home/types';
import type EnterpriseProgramsV1 from 'bundles/naptimejs/resources/enterprisePrograms.v1';

export function sortProgramsByTitle(programs: Array<EnterpriseProgramsV1>) {
  return sortBy(programs, (program) => {
    return program.metadata.name;
  });
}

export type ProgramNameList = { id: string; name: string; isArchived: boolean }[];

export function getProgramNameList(programs: Array<EnterpriseProgramsV1>): ProgramNameList {
  return programs.map((program) => ({
    id: program.id,
    name: program.metadata.name,
    isArchived: !!program.metadata.endedAt,
  }));
}

export function paginatePrograms(
  programs: Array<EnterpriseProgram>,
  programsPerPage: number
): PaginatedEnterprisePrograms {
  const paginatedPrograms = {} as PaginatedEnterprisePrograms;
  programs.forEach((program, index) => {
    const pageNumber = floor(index / programsPerPage) + 1;
    if (index % programsPerPage === 0) {
      paginatedPrograms[pageNumber] = [program];
    } else {
      paginatedPrograms[pageNumber].push(program);
    }
  });
  return paginatedPrograms;
}
